module.exports = __webpack_public_path__ + "static/logo-282951d9060973e55ab5177fc6661c51.png";